import React from 'react';
import styled from 'styled-components/macro';
import { Paper, Typography, Box } from '@mui/material';
import LoginConfirmVerified from '../../components/auth/LoginConfirmVerified';

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

export const ConfirmCode: React.FC = () => {
  return (
    <React.Fragment>
      <Wrapper>
        <Typography variant="h3" paragraph>
          Please enter authenticate code!
        </Typography>
        <Typography sx={{ color: 'text.secondary' }}>
          We send a 6-digit confirmation code, please enter the code in the below box to verify your
          account.
        </Typography>
        <Box sx={{ mt: 5, mb: 3 }}>
          <LoginConfirmVerified />
        </Box>
      </Wrapper>
    </React.Fragment>
  );
};
